export type RecommendationsTitleTag = "span" | "h2" | "h3";

const TITLE_TAGS: readonly RecommendationsTitleTag[] = ["span", "h2", "h3"];

/**
 * PDP section titles (`app.config.ts` → `productRecommendations.titleTag`):
 * a `span` keeps the fixed `text-3xl` (`titleClass`), a heading takes the
 * template's heading sizes. Cast: vue-tsc infers the app config as `unknown`.
 */
export const useProductRecommendationsConfig = (): {
	titleTag: RecommendationsTitleTag;
	titleClass: string;
} => {
	const { productRecommendations } = useAppConfig() as {
		productRecommendations?: { titleTag?: unknown };
	};
	const tag = productRecommendations?.titleTag;
	const titleTag = TITLE_TAGS.find((allowed) => allowed === tag) ?? "span";
	return { titleTag, titleClass: titleTag === "span" ? "text-3xl" : "" };
};
